document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('[data-accordeon-header]');

    headers.forEach(header => {
        header.addEventListener('click', function () {
            const body = this.nextElementSibling;
            document.querySelectorAll('[data-accordeon-body]').forEach(item => {
                if (item !== body) {
                    item.classList.remove('active');
                    item.previousElementSibling.classList.remove('active');
                }
            });

            body.classList.toggle('active');
            this.classList.toggle('active');
        });
    });
});